(function(){
  'use strict';

  function init(){
    if(window.innerWidth > 749) return;

    var footer = document.querySelector('.footer');
    if(!footer) return;

    var blocks = footer.querySelectorAll('.footer-block');

    blocks.forEach(function(block){

      // Skip newsletter / brand blocks (non-collapsible)
      if(
        block.classList.contains('footer-block--newsletter') ||
        block.classList.contains('footer-block--brand-information') ||
        block.classList.contains('footer-block--image')
      ) return;

      // ── Case 1: block already uses <details> ──
      var details = block.querySelector('details');
      if(details){
        // Force close on load
        details.removeAttribute('open');
        // CSS already handles +/− via ::after
        return;
      }

      // ── Case 2: flat heading + content — build accordion ──
      var heading = block.querySelector('.footer-block__heading');
      var content = block.querySelector('.footer-block__details-content');
      if(!heading || !content) return;

      // Button
      var btn = document.createElement('button');
      btn.className = 'ruvr-acc-btn';
      btn.type = 'button';
      btn.setAttribute('aria-expanded','false');

      var label = document.createElement('span');
      label.className = 'ruvr-acc-label';
      label.textContent = heading.textContent.trim();

      var icon = document.createElement('span');
      icon.className = 'ruvr-acc-icon';
      icon.setAttribute('aria-hidden','true');
      icon.textContent = '+';

      btn.appendChild(label);
      btn.appendChild(icon);

      // Content wrapper — starts closed
      var body = document.createElement('div');
      body.className = 'ruvr-acc-body no-transition';

      while(content.firstChild){
        body.appendChild(content.firstChild);
      }

      // Replace in DOM
      heading.replaceWith(btn);
      content.replaceWith(body);

      // Remove no-transition after first paint
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          body.classList.remove('no-transition');
        });
      });

      // Toggle
      btn.addEventListener('click', function(){
        var isOpen = body.classList.contains('open');
        body.classList.toggle('open', !isOpen);
        icon.textContent = isOpen ? '+' : '\u2212';
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
